module.exports = __webpack_public_path__ + "static/media/login-icon-email.7e8fbd79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-icon-email.svg
// module id = 1106
// module chunks = 0